import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import Datagrid from '../../../UI/Datagrid';
import ActionsDropdown from '../../Dashboard/helpers/ActionsDropdown';
import Moment from 'moment';
import { selectFilter } from 'react-bootstrap-table2-filter';
import AckAlarm from '../../Dashboard/AckAlarm';
import { connect } from 'react-redux';
import helper from '../../../../utils/helper';
import { dashboardActions } from '../../../../actions/dashboard.action';
import { bindActionCreators } from 'redux';
import { isEmpty, cloneDeep } from 'lodash';
import { Button } from '../../../UI/Common';
import { useHistory, useLocation } from 'react-router';
import '../../Dashboard/helpers/dashboard.scss';
import { CustomInput, FormGroup } from 'reactstrap';
import { getAlarmList } from '../../../../api/dashboard';
import {
  getSharedDefaultStyles,
  getSpacingAround,
} from '../../Configure/DashboardCustom/functions';

const dateFormat = 'MM/DD/yyyy HH:mm:ss';
const selectOptions = {
  0: 'All',
  1: 'This Hour',
  2: 'Last Hour',
  3: 'Yesterday',
  4: 'Today',
};
function getTrendChartDefaultPeriodHours() {
  const trendChartDefaultPeriodHours = helper.getSetting(
    'TrendChartDefaultPeriodHours',
  );
  return parseInt(trendChartDefaultPeriodHours.value);
}
const AlarmListWidget = (props) => {
  const refreshRate = helper.getSetting('ValueRefreshRateSec').value * 1000;
  const locale = localStorage.getItem('language') || 'en_US';
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation('app');
  const { groupId } = helper.parseQueryString(location.search);
  const [shouldHideInactive, setHideInactiveFlag] = React.useState(false);
  const [alarmList, updateAlarmList] = React.useState([]);
  const [selectedAlarm, setSelectedAlarm] = React.useState([]);
  const intervalRef = React.useRef();
  const [didMount, setDidMount] = React.useState(false);

  function getData() {
    getAlarmList()
      .then((resp) => updateAlarmList(resp))
      .catch((err) => console.log('alarm list err', err));
  }

  const getIntervalData = () => {
    const interval = setInterval(() => {
      getData();
    }, refreshRate);
    return interval;
  };

  React.useEffect(() => {
    getData();
    intervalRef.current = getIntervalData();
    setDidMount(true);
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  React.useEffect(() => {
    if (selectedAlarm.length) {
      clearInterval(intervalRef.current);
    }
    if (!selectedAlarm.length && didMount) {
      intervalRef.current = getIntervalData();
    }
  }, [selectedAlarm.length]);

  const columns = [
    {
      dataField: 'timeDetected',
      text: 'Time Detected',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
      filter: selectFilter({
        options: selectOptions,
        defaultValue: '0',
        id: 'time-detected-filter',
        onFilter: filterTimeDetected,
      }),
    },
    {
      dataField: 'department',
      text: 'Department',
      sort: true,
      hidden: groupId ? true : false,
      headerStyle: () => {
        if (groupId) {
          return { display: 'none' };
        }
      },
      style: () => {
        if (groupId) {
          return { display: 'none' };
        }
      },
    },
    {
      dataField: 'group',
      text: 'Group',
      sort: true,
      hidden: groupId ? true : false,
      headerStyle: () => {
        if (groupId) {
          return { display: 'none' };
        }
      },
      style: () => {
        if (groupId) {
          return { display: 'none' };
        }
      },
    },
    {
      dataField: 'location',
      text: 'Location',
      sort: true,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'parameter',
      text: 'Parameter',
      sort: true,
      headerStyle: { width: 100, textAlign: 'center' },
      style: { textAlign: 'center' },
    },
    {
      dataField: 'acknowledged',
      text: 'Ack',
      sort: true,
      headerStyle: { width: 60, textAlign: 'center' },
      style: { textAlign: 'center' },
      formatter: (cell) => (cell ? 'Yes' : 'No'),
      filterValue: (cell) => (cell ? 'Yes' : 'No'),
    },
    {
      dataField: 'alarmStatus',
      text: 'Alarm Status',
      sort: true,
      headerStyle: { width: '20%' },
    },
    {
      dataField: 'dumCol',
      text: 'Currently Active',
      hidden: true,
      // formatter: (cell, row) =>
      //   row.color.match(/red|cyan\/blue|yellow/g) ? 'Yes' : 'No',
      csvFormatter: (cell, row) =>
        row.color.match(/red|cyan\/blue|yellow/g) ? 'Yes' : 'No',
    },
  ];
  const defaultSorted = [
    {
      dataField: 'timeDetected',
      order: 'desc',
    },
  ];
  function rowClasses(row) {
    let className = '';
    switch (row.color.toLowerCase()) {
      case 'red':
        className = 'bg-red';
        break;
      case 'cyan/blue':
        className = 'bg-blue';
        break;
      case 'yellow':
        className = 'bg-yellow';
        break;
      default:
        break;
    }
    return className;
  }
  const ctxMenuOptions = [
    [
      {
        name: 'Ack alarm',
        className: () =>
          helper.checkPermission('API.AckAlarms') ? '' : 'item-disabled',
        action: (row, rowIndex) => {
          setAckAlarmProps({
            isOpen: true,
            sensorIds: [row.sensorId],
            sensorName: row.name,
          });
        },
      },
      {
        name: 'Add note',
        className: () =>
          helper.checkPermission('API.Notes') ? '' : 'item-disabled',
        action: (row, rowIndex) => {
          history.push(
            `/add-note?sensorIds=${row.sensorId}&sensorName=${row.name}`,
          );
        },
      },
      {
        name: 'Show trend chart',
        action: (row, rowIndex) => {
          const hours = getTrendChartDefaultPeriodHours();
          const toDate = toUTC(Moment().toDate());
          const fromDate = toUTC(Moment().subtract(hours, 'hours').toDate());
          history.push(
            `/trend-charts?sensorIds=${row.sensorId}&fromDate=${fromDate}&toDate=${toDate}&locale=${locale}`,
          );
        },
      },
    ],
  ];
  function toUTC(dt) {
    return Moment.utc(dt, dateFormat).format();
  }
  function filterTimeDetected(filterVal, data) {
    switch (filterVal) {
      case '0':
        return data;
      case '1':
        return data.filter((d) =>
          Moment(new Date(d.timeDetected)).isBetween(
            Moment().startOf('hour'),
            Moment(),
            undefined,
            '[]',
          ),
        );
      case '2':
        return data.filter((d) =>
          Moment(new Date(d.timeDetected)).isBetween(
            Moment().subtract(1, 'hours'),
            Moment(),
            undefined,
            '[]',
          ),
        );
      case '3':
        return data.filter((d) =>
          Moment(new Date(d.timeDetected)).isBetween(
            Moment().subtract(1, 'days'),
            Moment(),
            undefined,
            '[]',
          ),
        );
      default:
        return data.filter((d) =>
          Moment(new Date(d.timeDetected)).isBetween(
            Moment().startOf('day'),
            Moment(),
            undefined,
            '[]',
          ),
        );
    }
  }
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedAlarm([...selectedAlarm, row.sensorId]);
    } else {
      setSelectedAlarm(selectedAlarm.filter((x) => x !== row.sensorId));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSelectedAlarm((selectedAlarm) => [
        ...selectedAlarm,
        ...ids.filter((id) => !selectedAlarm.includes(id)),
      ]);
    } else {
      setSelectedAlarm((selectedAlarm) =>
        selectedAlarm.filter((sensorId) => !ids.includes(sensorId)),
      );
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedAlarm,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };

  const actions = [
    {
      label: 'Ack alarm',
      action: ackAlarm,
      disabled: !(
        selectedAlarm.length && helper.checkPermission('API.AckAlarms')
      ),
    },
    {
      label: 'Add note',
      action: addNote,
      disabled: !(selectedAlarm.length && helper.checkPermission('API.Notes')),
    },
    {
      label: 'Show trend chart',
      action: showTrendChart,
      disabled: !selectedAlarm.length || selectedAlarm.length > 4,
    },
  ];
  function showTrendChart(e) {
    e.preventDefault();
    const hours = getTrendChartDefaultPeriodHours();
    const toDate = toUTC(Moment().toDate());
    const fromDate = toUTC(Moment().subtract(hours, 'hours').toDate());
    history.push(
      `/trend-charts?sensorIds=${selectedAlarm.join(
        ',',
      )}&fromDate=${fromDate}&toDate=${toDate}&locale=${locale}`,
    );
  }

  function ackAlarm(e) {
    e.preventDefault();
    let sensorName = '';
    if (selectedAlarm.length > 1) {
      sensorName = '<Multiple alarms>';
    } else {
      let result = alarmList.filter(
        (al) => al.sensorId === selectedAlarm[0],
      )[0];
      if (result) {
        sensorName = result.name;
      }
    }
    setAckAlarmProps({
      isOpen: true,
      sensorIds: selectedAlarm,
      sensorName,
    });
  }

  function addNote(e) {
    e.preventDefault();
    let sensorName = '';
    if (selectedAlarm.length > 1) {
      sensorName = '<Multiple alarms>';
    } else {
      let result = alarmList.filter(
        (al) => al.sensorId === selectedAlarm[0],
      )[0];
      if (result) {
        sensorName = result.name;
      }
    }
    history.push(
      `/add-note?sensorIds=${selectedAlarm.join(',')}&sensorName=${sensorName}`,
    );
  }
  React.useEffect(() => {
    setSelectedAlarm(
      selectedAlarm.filter((alarm) =>
        alarmList.filter((al) => al.sensorId === alarm),
      ),
    );
  }, [alarmList]);
  const [ackAlarmProps, setAckAlarmProps] = React.useState({
    isOpen: false,
    sensorIds: [],
    sensorName: '',
  });

  //   const summaries = cloneDeep(props.dashboard.availableGroupsSummaries);
  //   function checkSummaries() {
  //     return isEmpty(summaries) && isEmpty(summaries[0]);
  //   }
  function getDataByMode(data) {
    switch (props.extraProperties.mode) {
      case 2:
        if (groupId) {
          return data.filter((al) => al.groupId.toString() === groupId);
        } else return data;
      case 3:
        return data.filter(
          (al) => al.groupId === props.extraProperties.filteredByGroup,
        );
      default:
        return data;
    }
  }
  function filterAlarmList() {
    const _alarmList = getDataByMode(alarmList);
    console.log(_alarmList);
    if (shouldHideInactive) {
      return _alarmList.filter((alarm) =>
        alarm.color.match(/red|cyan\/blue|yellow/g),
      );
    } else {
      return _alarmList;
    }
  }
  function getStyles() {
    let val = parseInt(props.width);
    return {
      width: val < 0 ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        props.extraProperties.spacingTop,
        props.extraProperties.spacingRight,
        props.extraProperties.spacingBottom,
        props.extraProperties.spacingLeft,
      ),
    };
  }
  return (
    <>
      <AckAlarm
        {...ackAlarmProps}
        t={t}
        onCancel={() =>
          setAckAlarmProps({ sensorIds: selectedAlarm, isOpen: false })
        }
        onAdd={() => {
          setAckAlarmProps({ sensorIds: selectedAlarm, isOpen: false });
          getData();
        }}
      />

      <div style={getStyles()}>
        <div className="d-flex justify-content-between align-items-end mb-10">
          {/* <div>
          {props.shouldRenderBackBtn ? (
            <Button onClick={props.onBack}>Back</Button>
          ) : null}
          <h1 style={{ margin: 0 }}>
            {t('Alarm list')}
            {props.groupName
              ? `: ${props.groupName} (${props.groupState})`
              : null}
          </h1>
        </div> */}
          <div>
            {props.title ? <h1>{props.title}</h1> : null}
            {props.description ? (
              <span style={{ fontStyle: 'italic' }}>{props.description}</span>
            ) : null}
          </div>
          <div className="d-flex flex-1 justify-content-end align-items-end">
            <FormGroup className="mb-0 mr-5">
              <CustomInput
                type="checkbox"
                id="show-active-switch"
                label={t('Hide Inactive')}
                checked={shouldHideInactive}
                onChange={(e) => setHideInactiveFlag(e.target.checked)}
              />
            </FormGroup>
            <ActionsDropdown options={actions} />
          </div>
        </div>
        <Datagrid
          datagridProps={{
            keyField: 'sensorId',
            data: filterAlarmList(),
            columns,
            defaultSorted,
            rowClasses,
            selectRow,
          }}
          classes=""
          showLog
          ctxMenuId="AlarmList-context"
          ctxMenuOptions={ctxMenuOptions}
          exportProps={{
            fileName: `AlarmList-${Moment().format('MM-DD-YYYY')}.csv`,
          }}
        />
      </div>
    </>
  );
};

export default AlarmListWidget;
